import gql from 'graphql-tag'

export default gql`
{
  productGroup
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/productGroup.js